import { __rest } from "tslib";
import * as React from 'react';
import { Button, Tooltip } from '@patternfly/react-core';
import { CodeEditorContext } from './CodeEditorUtils';
export const CodeEditorControl = (_a) => {
    var { icon, className, 'aria-label': ariaLabel, toolTipText, exitDelay, entryDelay, maxWidth, position, onClick = () => { }, isVisible = true, tooltipProps = {} } = _a, props = __rest(_a, ["icon", "className", 'aria-label', "toolTipText", "exitDelay", "entryDelay", "maxWidth", "position", "onClick", "isVisible", "tooltipProps"]);
    const context = React.useContext(CodeEditorContext);
    if (entryDelay !== undefined) {
        // eslint-disable-next-line no-console
        console.warn('CodeEditorControl: entryDelay prop has been deprecated. ' +
            'Pass the entryDelay via the tooltipProps prop instead.');
    }
    if (exitDelay !== undefined) {
        // eslint-disable-next-line no-console
        console.warn('CodeEditorControl: exitDelay prop has been deprecated. ' +
            'Pass the exitDelay via the tooltipProps prop instead.');
    }
    if (maxWidth !== undefined) {
        // eslint-disable-next-line no-console
        console.warn('CodeEditorControl: maxWidth prop has been deprecated. ' + 'Pass the maxWidth via the tooltipProps prop instead.');
    }
    if (position !== undefined) {
        // eslint-disable-next-line no-console
        console.warn('CodeEditorControl: position prop has been deprecated. ' + 'Pass the position via the tooltipProps prop instead.');
    }
    if (toolTipText !== undefined) {
        // eslint-disable-next-line no-console
        console.warn('CodeEditorControl: toolTipText prop has been deprecated. ' +
            'Pass the toolTipText by setting the content field in tooltipProps prop instead.');
    }
    const onCustomClick = (event) => {
        onClick(context.code, event);
    };
    return isVisible ? (React.createElement(Tooltip, Object.assign({ exitDelay: exitDelay, entryDelay: entryDelay, maxWidth: maxWidth, position: position, content: React.createElement("div", null, toolTipText) }, tooltipProps),
        React.createElement(Button, Object.assign({ className: className, onClick: onCustomClick, variant: "control", "aria-label": ariaLabel }, props), icon))) : null;
};
CodeEditorControl.displayName = 'CodeEditorControl';
//# sourceMappingURL=CodeEditorControl.js.map